import { TabList } from '@chakra-ui/react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const StyledTabList = ({ children }: { children: any }) => {
  return <TabList borderColor="neutral.100">{children}</TabList>
}

export default StyledTabList
